import { VideoGrid } from '@blocks';
import { Box } from '@ui';

import { useVideoPayload } from './hooks/useVideoPayload';
import * as css from './styles.css';

export const LiveAnalysisCameras = () => {
    const videoPayload = useVideoPayload();
    const isSingleVideo = videoPayload.length === 1;

    return (
        <Box className={css.grid({ columns: isSingleVideo ? 'single' : 'double' })}>
            {videoPayload.map((video) => (
                <VideoGrid
                    key={video?.id}
                    mode="scrub"
                    columns={1}
                    videos={[video]}
                    currentFrame={0}
                    maxFrame={1}
                    playbackSpeed={1}
                />
            ))}
        </Box>
    );
};
